export default __webpack_public_path__ + "static/media/Prologue_Aurora1US.170e3e00.png";